import isArray from 'lodash/isArray'
import isPlainObject from 'lodash/isPlainObject'
import _ from 'lodash'
import { commonAddLog } from '@/api/biz/shipment/pack/paperlessPackageTag';
import { i18n } from '@/api/i18n';
import {$notify} from '@/global';
import {restUrls} from '@/api/rest/url';
import { pushPrintPoint } from '@/utils/setMethods';

// 注册钩子
let globalConfig = {
  // 参数
  options: {},
  // 头信息
  headers: {},
  // 缓存
  cache: true,
  // 请求后处理
  responseHandle () {}
}

// 将参数转换为queryStr
const toQueryStr = params => {
  const queryStrs = []
  flatPath(params).forEach(({key, value}) => {
    if (typeof value === 'undefined') {
      value = ''
    }
    value = encodeURIComponent(value)
    queryStrs.push(`${key}=${value}`)
  })
  return queryStrs.join('&')
}

// 递归拉平params
const flatPath = (obj, paths = []) => {
  let values = []
  if (typeof obj === 'object') {
    for (let p in obj) {
      if (obj.hasOwnProperty(p)) {
        const newPaths = [...paths]
        if (isArray(obj)) {
          // 数组情况需要组装成[0]格式
          let lastPath = newPaths.splice(paths.length - 1, 1)
          newPaths.push(`${lastPath}[${p}]`)
        } else {
          newPaths.push(p)
        }
        values = values.concat(flatPath(obj[p], newPaths))
      }
    }
  } else if (paths.length) {
    values.push({
      key: paths.join('.'),
      value: obj
    })
  }
  return values
}

const ajax = ({url = '', params = {}, async = true, method = 'get'}) => {
  const {options, headers, responseHandle} = globalConfig
  if (!_.isEmpty(params.authorization)) {
    headers.Authorization = params.authorization;
    delete params.authorization
  }
  return new Promise((resolve, reject) => {
    const queryStr = toQueryStr(params)
    const isCloudPrint = url === restUrls.cloud_print_url
    // get 将param拼接在url后面
    if (method === 'get') {
      if (params != null) url += '?' + queryStr
      params = null
    }

    const startTime = new Date().getTime(); // 记录请求开始时间
    const xhr = new window.XMLHttpRequest()
    xhr.open(method, url, async)

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        let timeEnd = new Date().getTime()
        pushPrintPoint(url,timeEnd-startTime,startTime)
        if(xhr.status === 200){
          console.log('200', 'xhr.responseText=', xhr.responseText);
          console.log('200', 'xhr.response=', xhr.response);
          if(xhr.response && isCloudPrint){
            doCloudPrintCheck(xhr.response, params)
          }
        } else {
          console.error('xhr.status=', xhr.status, 'xhr.statusText=', xhr.statusText);
        }
        resolve(xhr)
      }
    }
    if (options && isPlainObject(options)) {
      for (let p in options) {
        if (options.hasOwnProperty(p)) {
          xhr[p] = options[p]
        }
      }
    }
    let contentType
    if (headers && isPlainObject(headers)) {
      for (let name in headers) {
        if (headers.hasOwnProperty(name)) {
          let value = headers[name]
          if (name === 'Content-Type') {
            contentType = value
          }
          // 兼容云打印
          if (name === 'template') {
            value = params.template
          }
          xhr.setRequestHeader(name, value)
        }
      }
    }
    // post请求需要判断ContentType
    if (method === 'post' || method === 'put' || method === 'patch' || method === 'delete') {
      params = contentType === 'application/json' ? JSON.stringify(params || {}) : queryStr
    }

    // 打单相关接口
    const urlList = [
      '/placeOrderApi/rest/placeOrder',
      '/printPlatformApi/doc/printAll',
      '/printPlatformApi/doc/print'
    ]

    // if(urlList.includes(url)) {
    //   // 异常上报
    //   xhr.onerror = (e) => {
    //     console.error(xhr.statusText);
    //     console.error(e)
    //     commonAddLog(
    //       'ajax.js',
    //       'commonPrint-url-error',
    //       `busiNo: ${params.outboundNo};打单逻辑相关,URL地址：${url},请求参数：${params};响应状态：${xhr.statusText}`,
    //       { alerm: true }
    //     )
    //   };
    // }

    xhr.onerror = (e) => {
      console.error('error', e);
      console.error(xhr.statusText);
      let errText = `busiNo: ${params.outboundNo};接口异常,URL地址：${url},请求参数：${params};响应状态：${xhr.statusText}`;
      // 云打印异常上报
      if(isCloudPrint){
        errText = `busiNo: ${params.outboundNo};云打印异常,URL地址：${url},请求参数：${params};响应状态：${xhr.statusText}`
        commonAjaxAddLog(errText)
        const flag = localStorage.getItem('notOpenCloudPrinter');
        if (flag !== '1') {
          localStorage.setItem('notOpenCloudPrinter', '1');
          $notify.error(i18n.t('notopencloudprinterError'));
        }
      }
      // call单相关接口异常上报
      if(urlList.includes(url)) {
        errText = `busiNo: ${params.outboundNo};打单逻辑相关,URL地址：${url},请求参数：${params};响应状态：${xhr.statusText}`
        commonAjaxAddLog(errText, true)
        return
      }
      // 异常上报
      commonAjaxAddLog(errText)
    }

    xhr.ontimeout = (timeout) => {
      console.error('timeout', timeout);
      let errText = `busiNo: ${params.outboundNo};接口超时,URL地址：${url},请求参数：${params};响应状态：${xhr.statusText}`;
      // 云打印超时上报
      if(isCloudPrint){
        errText = `busiNo: ${params.outboundNo};云打印超时,URL地址：${url},请求参数：${params};响应状态：${xhr.statusText}`
        commonAjaxAddLog(errText)
        $notify.error(i18n.t('1400037'));
      }
      // 超时上报
      commonAjaxAddLog(errText)
      $notify.error(i18n.t('1400037'));
    }

    xhr.send(params)
  }).then(responseHandle)
}

const get = (url, params = {}, async) => {
  if (!globalConfig.cache) {
    params['__ts__'] = new Date().getTime()
  }
  return ajax({
    url,
    params,
    async,
    method: 'get'
  })
}
const getNoTs = (url, params = {}, async) => {
  return ajax({
    url,
    params,
    async,
    method: 'get'
  })
}

const post = (url, params = {}, async) => {
  return ajax({
    url,
    params,
    async,
    method: 'post'
  })
}

// put
const put = (url, params = {}, async) => {
  return ajax({
    url,
    params,
    async,
    method: 'put'
  })
}

// patch
const patch = (url, params = {}, async) => {
  return ajax({
    url,
    params,
    async,
    method: 'patch'
  })
}

// del
const del = (url, params = {}, async) => {
  return ajax({
    url,
    params,
    async,
    method: 'delete'
  })
}

// setConfig
const setConfig = config => {
  globalConfig = Object.assign({}, globalConfig, config)
}

// 日志上报
const commonAjaxAddLog = (errText, alerm = false) => {
  let logStrInfo = errText
  if(logStrInfo && logStrInfo.length > 3000){
    logStrInfo.substring(0, 100)
  }
  commonAddLog(
    'ajax.js',
    'commonPrint-url-error',
    logStrInfo,
    { alerm }
  )
}

// 云打印异常校验
const doCloudPrintCheck = (response, payload) => {
  try {
    const responseInfo = JSON.parse(response)[0]
    const {template, templateVer} = JSON.parse(payload)
    // 异常
    if(responseInfo && responseInfo.status !== 0){
      console.log(`云打印异常信息errMsg: ${responseInfo.errMsg},errCode: ${responseInfo.errCode}`)
      const errText = `云打印异常,云打印异常信息errMsg: ${responseInfo.errMsg},errCode: ${responseInfo.errCode}`
      commonAjaxAddLog(errText)
      switch (responseInfo.errCode) {
        case "400":
          $notify.error(i18n.t('cloudPrintTemplateNotExist', [template]));
          break;
        case "600":
          // 硬编码兼容
          if(typeof responseInfo.errMsg === 'string' && responseInfo.errMsg.includes('File not in PDF format or corrupted')){
            $notify.error(responseInfo.errMsg);
          } else {
            $notify.error(i18n.t('cloudPrintTemplateNotExistOrVersionNotMatch',[template, templateVer]));
          }
          break;
        default:
          $notify.error(responseInfo.errMsg);
          break;
      }
    }
  } catch (error) {
    console.log(error)
  }
}

export {
  setConfig,
  getNoTs,
  get,
  post,
  put,
  patch,
  del
}
export default get
